module.exports = __webpack_public_path__ + "img/dark_baggage.ccce87d7.png";